import { AppBar, Box, Button, Grid, IconButton, Input, InputAdornment, Stack, TextField, Typography } from "@mui/material"
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { useRef, useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { appApi } from "src/apiUtils/AppApi";
import { url } from "src/apiUtils/apiPath";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import LanguageOutlinedIcon from '@mui/icons-material/LanguageOutlined';
import HelpOutlineOutlinedIcon from '@mui/icons-material/HelpOutlineOutlined';
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';

function Login() {


    const myRefs = useRef([]);
    const navigate = useNavigate()
    const [eyeIcon, setEyeIcon] = useState(false)
    const [userLoginDtl, setUserLoginDtl] = useState({
        user_login_id: null,
        password: null
    })
    // const [autoFoucs, setAutoFoucs] = useState(1)
    const loginApi = () => {
        const data = userLoginDtl
        appApi(url.ADMIN_LOGIN, "POST", { 'Content-Type': 'application/json' }, JSON.stringify(data)).then((result) => {

            console.log("USER_LOGIN", result);
            if (result && result.status === true) {
                localStorage.setItem("userLoginDetail", JSON.stringify(result.data.entity))
                localStorage.setItem("deviceToken", result.data.token)
                navigate('/admin/dashboard')
            }
            else {
                notify(result.message)
            }
        })
    }
    const handleKeyUp = (e, targetElem) => {
        if (e.key === "Enter" && targetElem) {
            targetElem.focus();
        }
    };
    const notify = (msg) => toast.error(
        msg,
        {
            width: "10%",
            pauseOnHover: false,
            autoClose: 2000,
            position: 'top-center'
        }
    );
    useEffect(() => {
        const localToken = localStorage.getItem("deviceToken")
        if (localToken) {
            navigate('/admin/dashboard')
        }
    })
    return (

        <Box
            sx={{
                height: '100%',
                width: '100%',
                // backgroundImage: `url("assets/landing/Group 7466.svg")`,
                backgroundColor: 'background.primary',
                backgroundRepeat: 'no-repeat',
                backgroundPositon: 'center center',
                backgroundSize: 'cover'
            }}>
            <AppBar position="static" sx={{
                backgroundColor: 'common.white',
                paddingLeft: "8%",
                paddingRight: "8%",
                paddingTop: "1%",
                paddingBottom: "1%"
            }}>
                <Stack direction={'row'} justifyContent={'space-between'}>
                    <Box>
                        <img src='assets/landing/mapskil_logo_wording.png' alt='logo' width={"15%"} height={"110%"} />
                    </Box>
                    <Box sx={{ paddingTop: 1 }}>
                        <LanguageOutlinedIcon sx={{ color: 'button.secondary' }} />
                        <HelpOutlineOutlinedIcon sx={{ color: 'button.secondary', marginLeft: 2 }} />
                    </Box>
                </Stack>
            </AppBar>
            <Grid container
                sx={{
                    height: '90%',
                    width: '100%'
                }}
            >
                <Grid item xl={6} lg={6} md={6}
                    sx={{
                        display: {
                            xl: 'flex',
                            lg: 'flex',
                            md: 'flex',
                            sm: 'none',
                            xs: 'none'
                        },
                        alignItems: 'center',
                        justifyContent: 'center'
                    }}
                >
                    <img src='assets/landing/container61.png' alt='logo' width={"65%"} height={"65%"} />
                </Grid>
                <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
                    <Box
                        sx={{
                            height: '100%',
                            width: '100%',
                            display: 'flex',
                            flexDirection: 'column'
                        }}
                    >
                        <Box
                            sx={{
                                height: '100%',
                                width: '100%',
                                display: 'flex',
                                flexDirection: 'column',
                                justifyContent: 'flex-start',
                                alignItems: 'center',
                                marginTop: '20%'
                            }}>

                            <Box sx={{
                                height: '80%',
                                width: {
                                    xl: '60%',
                                    lg: '60%',
                                    md: '60%',
                                    sm: '80%',
                                    xs: '80%'
                                },
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                border: '1px solid white',
                                borderRadius: '10px',
                                boxShadow: '-2px 3px 47px -7px rgba(0,0,0,0.1);',
                                backgroundColor: 'common.white'
                            }}
                            >
                                <Box
                                    sx={{
                                        flexDirection: 'column',
                                        height: '100%',
                                        width: '90%',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'space-evenly'
                                    }}>
                                    <Stack direction={'Column'} sx={{
                                        display: 'flex',
                                        alignItems: 'flex-start',
                                        justifyContent: 'space-evenly',
                                        width: '100%'
                                    }}>
                                        <Stack direction={'row'}>
                                            <Typography fontWeight={'bold'} variant="h3" sx={{ display: 'flex' }}>Welcome back </Typography>

                                            <Box sx={{ padding: 1 }}>
                                                <img src='assets/landing/waving-hand.svg' alt='logo' width={"35"} height={"35"} />
                                            </Box>
                                        </Stack>
                                        <Typography fontWeight={'bold'} variant="h5" color={'button.secondary'}>Log in your account</Typography>

                                    </Stack>
                                    <Stack sx={{
                                        width: '100%'
                                    }}>
                                        <TextField
                                            fullWidth
                                            justifyContent='center'
                                            placeholder="Enter Username"
                                            LockOutlinedIcon
                                            onChange={(event) => {
                                                setUserLoginDtl((prevUserLoginDtl) => ({
                                                    ...prevUserLoginDtl,
                                                    user_login_id: event.target.value
                                                }));
                                            }}
                                            InputProps={{
                                                startAdornment:
                                                    <InputAdornment>
                                                        <EmailOutlinedIcon style={{ margin: '3px' }} />
                                                    </InputAdornment>,
                                                style: {
                                                    backgroundColor: '#F6F6F6',
                                                    borderRadius: 10,
                                                    height: '60px',
                                                    padding: "5px"
                                                },
                                                disableUnderline: 'true'
                                            }}
                                        />
                                    </Stack>
                                    <Stack sx={{
                                        width: '100%'
                                    }}>
                                        <TextField
                                            fullWidth
                                            justifyContent='center'
                                            placeholder="Enter Password"
                                            LockOutlinedIcon
                                            onChange={(event) => {
                                                setUserLoginDtl((prevUserLoginDtl) => ({
                                                    ...prevUserLoginDtl,
                                                    password: event.target.value
                                                }));
                                            }}
                                            onKeyUp={(e) => {
                                                if (e.key === "Enter") {
                                                    loginApi()
                                                }
                                            }}
                                            InputProps={{
                                                startAdornment:
                                                    <InputAdornment>
                                                        <LockOutlinedIcon style={{ margin: '3px' }} />
                                                    </InputAdornment>,
                                                style: {
                                                    backgroundColor: '#F6F6F6',
                                                    borderRadius: 10,
                                                    height: '60px',
                                                    padding: "5px"
                                                },
                                                type: eyeIcon ? "text" : "password",

                                                disableUnderline: 'true',
                                                endAdornment:
                                                    <InputAdornment>
                                                        {eyeIcon ?
                                                            <IconButton
                                                                onClick={() => {
                                                                    setEyeIcon(!eyeIcon)
                                                                }} >
                                                                <VisibilityIcon />
                                                            </IconButton> :
                                                            <IconButton
                                                                onClick={() => {
                                                                    setEyeIcon(!eyeIcon)
                                                                }} >
                                                                <VisibilityOffIcon />
                                                            </IconButton>}
                                                    </InputAdornment>
                                            }}
                                        />
                                    </Stack>
                                    <Stack direction={'row'} justifyContent={'space-between'} width={'100%'}>
                                        <Box>
                                            <Stack direction={'row'} >
                                                <Box sx={{
                                                    paddingTop: 0.5
                                                }}>
                                                    <Input
                                                        type="checkbox"
                                                        disableUnderline={'true'}
                                                        sx={{
                                                            height: '14px',
                                                            width: '14px',
                                                        }}
                                                    />
                                                </Box>

                                                <Typography>&nbsp;Remember me</Typography>
                                            </Stack>
                                        </Box>
                                        <Box>
                                            <Link>Forgot password?</Link>
                                        </Box>
                                    </Stack>
                                    <Button
                                        fullWidth
                                        variant="contained"
                                        sx={{
                                            backgroundColor: 'button.theme', padding: 1, "&:hover": {
                                                backgroundColor: "button.theme"
                                            },
                                        }}
                                        onClick={() => {
                                            loginApi()
                                        }}
                                    >
                                        Continue
                                    </Button>
                                    <Stack direction={'row'} sx={{ marginTop: 4 }}>
                                        <Typography>Don't have an account &nbsp;</Typography>
                                        <Link>Sign up</Link>
                                    </Stack>
                                </Box>

                            </Box>
                        </Box>
                    </Box>
                </Grid>
            </Grid>
            <ToastContainer />
        </Box >
    )
}

export default Login